export default __webpack_public_path__ + "static/media/icon-support.72952480.svg";